import React from 'react';
import type { ReactElement } from 'react';

import { DesignLayout } from '@common/DesignLayout';

import { AccountData } from './AccountData';

export const Account = (): ReactElement => (
  <DesignLayout title="Информация об учетной записи">
    <AccountData />
  </DesignLayout>
);
